<script lang="ts" setup>
defineProps<{ visible: boolean, ui?: any }>()
</script>

<template>
  <UChip position="top-left" color="green" :show="visible"
    :ui="{ wrapper: 'justify-start', base: 'absolute rounded-full ring-0 dark:ring-gray-900 flex items-center justify-center text-white dark:text-gray-900 font-medium whitespace-nowrap', ...ui }">
    <slot />
    <template #content>
      <div class="w-full h-full bg-green-500 rounded-full" />
      <div class="w-full h-full bg-green-500 rounded-full absolute inset-0 animate-ping" />
    </template>
  </UChip>
</template>
